<template>
  <section id="main-content">
    <section class="wrapper">
      <section class="login container-fluid">
        <div class="container box-login">
          <div class="row">
            <div class="col-12 col-md-6 text-center">
              <h1>Esqueceu a senha?</h1>
            </div>
            <div class="col-12 col-md-6 col-form">
              <form method="POST" v-on:submit.prevent="recuperarSenha()" class="form-login esqueci-senha">
                <div class="form-group mb-4 text-center">
                  <label for="email" class="mb-2">Vamos enviar a senha pro seu e-mail!</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text text-center"><i class="far fa-envelope"></i></div>
                    </div>
                    <input id="email" :disabled="submit" type="email" class="form-control" name="email" v-model="email" placeholder="digite seu e-mail">
                    <div class="invalid-feedback" v-if="erro">
                      {{ erro }}
                    </div>
                  </div>
                </div>

                <button type="button" class="btn btn-primary mb-2 btn-mostrar" :disabled="submit" @click="recuperarSenha()"><i class="fas fa-spinner fa-spin" v-if="submit"></i> Enviar senha</button>
                <p><a @click="$router.push('/login')" href="javascript:void(0)">Voltar para o login</a></p><br><br>

                <b-alert :variant="alerta.variant" :show="alerta.visivel" @dismissed="alerta.visivel=false">
                  <span v-html="alerta.mensagem"></span>
                </b-alert>
              </form>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import ValidationUtils from '@/core/utils/validation-utils'
import UsuarioAPI from '@/api/usuario-api'

export default {
  name: 'RecuperarSenhaView',
  data () {
    return {
      email: '',
      erro: '',
      alerta: {
        visivel: false,
        variant: 'success',
        mensagem: ''
      },
      submit: false
    }
  },

  created () {
    document.body.classList.add('login')
  },

  destroyed () {
    document.body.classList.remove('login')
  },

  methods: {
    recuperarSenha: function () {
      this.submit = true
      this.erro = ''
      this.alerta = { visivel: false }

      if (!this.email) {
        this.erro = 'Por favor informe o seu e-mail.'
        this.submit = false
      } else if (!ValidationUtils.email(this.email)) {
        this.erro = 'O e-mail informado não é válido.'
        this.submit = false
      } else {
        UsuarioAPI.recuperarSenha(this.email).then(data => {
          if (data.status) {
            const mensagem = '<strong>Enviado com sucesso!</strong><br> Siga as informações enviadas por e-mail.'
            this.alerta = { visivel: true, mensagem: mensagem, variant: 'success' }
          } else {
            const mensagem = Object.keys(data).reduce((result, value) => result + ' ' + data[value], '').trim()
            this.alerta = { visivel: true, mensagem: mensagem, variant: 'danger' }
          }
        }).catch(() => {
          this.alerta = {
            visivel: true,
            mensagem: '<strong>Ocorreu um erro!</strong><br> Por favor tente novamente mais tarde ou entre em contato com o responsável.',
            variant: 'danger'
          }
        }).then(() => {
          this.submit = false
        })
      }
    }
  }
}
</script>

<style scoped>
  .invalid-feedback {
    display: block;
    text-align: left;
  }
</style>
